import { render, staticRenderFns } from "./ScrollAuto.vue?vue&type=template&id=0dcaf419&"
import script from "./ScrollAuto.vue?vue&type=script&lang=js&"
export * from "./ScrollAuto.vue?vue&type=script&lang=js&"
import style0 from "./ScrollAuto.vue?vue&type=style&index=0&id=0dcaf419&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports